import { useState, useEffect, useCallback } from 'react';
import { orgDevTeamAPI } from '../services/strategicPerformanceApi';
import { useAuth } from '../../../contexts/AuthContext';

export function useOrganizationDevelopmentAccess() {
  const { user } = useAuth();
  const [isOrgDevTeamMember, setIsOrgDevTeamMember] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const checkAccess = useCallback(async () => {
    if (!user?.id) {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const members = await orgDevTeamAPI.getAll();
      // Check if current user's Microsoft ID is in the team
      const isMember = members.some(m => m.userMicrosoftId === user.id);
      setIsOrgDevTeamMember(isMember);
    } catch (error) {
      console.error('Error checking org dev team access:', error);
      setIsOrgDevTeamMember(false);
    } finally {
      setIsLoading(false);
    }
  }, [user?.id]);

  useEffect(() => {
    checkAccess();
  }, [checkAccess]);

  // Check if user is admin (from user context)
  const isAdmin = user?.isStrategicPerformanceSuperUser || false;
  const hasOrgDevelopmentAccess = isAdmin || isOrgDevTeamMember;

  return { hasOrgDevelopmentAccess, isLoading };
}
